"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplicaCustomReportMetadataQueryFields = exports.ReplicaReportMetadataQueryFields = exports.ReplicaReportMetadataFields = exports.ReplicaMetadataSnapshotQueryFields = exports.ReplicaMetadataQueryFields = exports.ReplicaMetadataFields = exports.ReplicaCampaignMetadataFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.ReplicaCampaignMetadataFields = {
    campaignId: core_1.IdSchema,
    teamId: core_1.IdSchema,
    country: core_1.CountrySchema,
    modifiedAt: core_1.TimestampSchema,
};
/**
 * Metadata fields required when creating a new record in the replica campaign.
 */
exports.ReplicaMetadataFields = {
    ...exports.ReplicaCampaignMetadataFields,
    campaignRef: ruby_1.AppleProxyRefSchema,
};
exports.ReplicaMetadataQueryFields = {
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    campaignRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    country: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.CountrySchema)),
};
exports.ReplicaMetadataSnapshotQueryFields = {
    ...exports.ReplicaMetadataQueryFields,
    ...core_1.DateFilterFields,
};
exports.ReplicaReportMetadataFields = {
    campaignId: core_1.IdSchema,
    teamId: core_1.IdSchema,
    country: core_1.CountrySchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
};
exports.ReplicaReportMetadataQueryFields = {
    ...exports.ReplicaMetadataQueryFields,
    ...core_1.DateFilterFields,
};
exports.ReplicaCustomReportMetadataQueryFields = {
    adamRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    country: typebox_1.Type.Optional(core_1.CountrySchema),
    ...core_1.DateFilterFields,
};
